exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mostrar{display:list-item;opacity:1;background:rgba(216,119,164,.7137254901960784);padding-top:15%}.image{width:100%;height:118%;-o-object-fit:contain;object-fit:contain;margin-top:-25px;z-index:100}", ""]);

// exports
